import FormEntryList from "./pages/ListPage.vue";
import FormEntryDetail from "./pages/FormPage.vue";
import FormEntryIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/form_entry",
    component: FormEntryIndex,
    redirect: "/form_entry/list",
    name: "form_entry",
    children: [
      {
        path: "list",
        component: FormEntryList,
        name: "form_entry.list",
      },
      {
        path: "create",
        component: FormEntryDetail,
        name: "form_entry.create",
        props: { create: true },
      },
      {
        path: "edit/:id/:state?",
        component: FormEntryDetail,
        name: "form_entry.edit",
        props: (route) => ({
          create: false,
          state: route.params.state,
        }),
      },
    ],
  },
];
